// pages/About/index.jsx
import React, { useEffect } from "react";
import { Container } from "../../styles/components";
import { Heart, Camera, Star, Clock } from "lucide-react";
import {
	AboutWrapper,
	HeroSection,
	HeroContent,
	Section,
	ValuesGrid,
	ValueCard,
} from "./styles";
import useNavbar from "../../hooks/useNavbar";

const values = [
	{
		icon: <Heart size={24} />,
		title: "Passion for Perfection",
		description:
			"We pour our hearts into every photo session, ensuring each image captures the pure joy and wonder of your little one.",
	},
	{
		icon: <Camera size={24} />,
		title: "Professional Excellence",
		description:
			"Using state-of-the-art equipment and techniques to create stunning, high-quality photographs that will last a lifetime.",
	},
	{
		icon: <Star size={24} />,
		title: "Customer First",
		description:
			"Your satisfaction is our priority. We work closely with you to understand your vision and exceed your expectations.",
	},
	{
		icon: <Clock size={24} />,
		title: "Timely Delivery",
		description:
			"We understand the excitement of seeing your photos, which is why we guarantee quick turnaround times without compromising quality.",
	},
];

const About = () => {
	const { setIsTransparent } = useNavbar();

	useEffect(() => {
		setIsTransparent(false);
		return () => setIsTransparent(true);
	}, [setIsTransparent]);

	return (
		<AboutWrapper>
			<HeroSection>
				<HeroContent>
					<h1>Capturing Life's Precious Moments</h1>
					<p>
						Specializing in newborn and baby photography, creating timeless
						memories for families to cherish forever.
					</p>
				</HeroContent>
			</HeroSection>

			<Container>
				<Section>
					<h2>Our Values</h2>
					<ValuesGrid>
						{values.map((value, index) => (
							<ValueCard
								key={value.title}
								initial={{ opacity: 0, y: 20 }}
								animate={{ opacity: 1, y: 0 }}
								transition={{ delay: index * 0.1 }}
							>
								<div className="icon">{value.icon}</div>
								<h3>{value.title}</h3>
								<p>{value.description}</p>
							</ValueCard>
						))}
					</ValuesGrid>
				</Section>
			</Container>
		</AboutWrapper>
	);
};

export default About;
